import { cn } from "@/components/podkit/lib/cn";
import { Text } from "@/components/podkit/typography/Text";
import { type FC, useMemo } from "react";

export type LabelPhase =
    "unspecified"
    | "stopped"
    | "deleted"
    | "stopping"
    | "starting"
    | "running"
    | "failed"
    | "succeeded";

export type PhaseLabelProps = {
    phase: LabelPhase;
}

export const PhaseLabel: FC<PhaseLabelProps> = ({ phase }) => {
    const variant: { label: string; textColor: string; bgColor: string } | undefined = useMemo(() => {
        switch (phase) {
            case "unspecified":
                return {
                    label: "Unspecified",
                    textColor: "text-content-tertiary",
                    bgColor: "bg-surface-03",
                };
            case "stopped":
                return {
                    label: "Stopped",
                    textColor: "text-content-tertiary",
                    bgColor: "bg-surface-03",
                };
            case "deleted":
                return {
                    label: "Deleted",
                    textColor: "text-content-tertiary",
                    bgColor: "bg-surface-03",
                };
            case "stopping":
                return {
                    label: "Stopping",
                    textColor: "text-content-yield",
                    bgColor: "bg-surface-yield",
                };
            case "starting":
                return {
                    label: "Starting",
                    textColor: "text-content-yield",
                    bgColor: "bg-surface-yield",
                };
            case "running":
                return {
                    label: "Running",
                    textColor: "text-content-green",
                    bgColor: "bg-surface-green",
                };
            case "failed":
                return {
                    label: "Failed",
                    textColor: "text-content-red",
                    bgColor: "bg-surface-red",
                };
            case "succeeded":
                return {
                    label: "Succeeded",
                    textColor: "text-content-green",
                    bgColor: "bg-surface-green",
                };
        }
    }, [phase]);

    if (!variant) {
        return null;
    }

    return (
        <div className={cn("flex content-center items-center rounded-xl px-2 py-[2px]", variant.bgColor)}>
            <Text className={cn("text-sm font-bold", variant.textColor)}>{variant.label}</Text>
        </div>
    );
};
